import {I18n} from '@aws-amplify/core';

import {FlexiAddButton,} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';
import {openModal} from "@mantine/modals";
import {Title} from "@mantine/core";
import {RecordForm} from "../forms/RecordForm.tsx";
import {usePaymentProfile} from '../hooks/usePaymentProfile.ts';
import {PaymentProfileStatus} from "../types.ts";

export const AddRecordButton = (
    {
        buttonText = 'Add Payment Profile',
        size = 'sm',
    }: {
        buttonText?: string,
        size?: string,
    }) => {

    const {id: customerId} = useParams()

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter')
    }

    // const navigate = useNavigate();
    //
    // if (typeof onClick === 'undefined') {
    //     onClick = () => {
    //         navigate(`/customers/${customerId}/payment-profiles/add`);
    //     };
    // }

    const {createRecord} = usePaymentProfile(customerId);


    const onClickHandler = () => openModal({
                                               title: <Title order={3}>Add Payment Profiles</Title>,
                                               size: 'xl',
                                               children: (
                                                   <RecordForm
                                                       handleSubmit={(values) => {
                                                           createRecord(values);
                                                           //closeAllModals();
                                                       }}
                                                       record={{
                                                           name: '',
                                                           status: PaymentProfileStatus.Active,
                                                           customerId: customerId,
                                                           created: new Date().toISOString(),
                                                       }}
                                                   />
                                               ),
                                           });

    return (
        <FlexiAddButton
            onClick={onClickHandler}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};
